import { IterableListItem } from "@/components/TriggerSetup/logic/types/types";
import { Guid } from "guid-typescript";

export class IterableItemFactory {
  create<T>(value: T): IterableListItem<T> {
    return { 'guid': Guid.create().toString(), 'value': value }
  }
}
